import { render, staticRenderFns } from "./InventoryItemPurchases.vue?vue&type=template&id=62fa2255&scoped=true&"
import script from "./InventoryItemPurchases.vue?vue&type=script&lang=js&"
export * from "./InventoryItemPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fa2255",
  null
  
)

export default component.exports